import React, { useEffect, useMemo, useReducer, useState } from 'react';
import { SiteFooter } from 'components/search/SiteFooter';
import { SiteHeader } from 'components/search/SiteHeader';
import DealsFilterSection from './DealsFilterSection';
import DealsFilterMobileSection from './DealsFilterMobileSection';
import { useCategories } from './categories';
import { dealsFilterReducer, initialFilterState } from './state';
import { useDealsForFilterState } from './deals';
import { DealsSection } from './DealsSection';
import { ReactComponent as CartWithCards } from '../../media/images/cart-with-cards.svg';
import Skeleton from 'react-loading-skeleton';
import { Btn } from 'components/btn/Btn';
import useMediaQueries from 'hooks/useMediaQueries';
import { withAuth } from 'features/auth/components/withAuth';

export const TopDealsScreen = withAuth()(() => {
    const [state, dispatch] = useReducer(dealsFilterReducer, initialFilterState);
    const { loading, deals } = useDealsForFilterState(state, 100);
    const categories = useCategories();
    const [type, setType] = useState<'desktop' | 'mobile'>('desktop');
    const queries = useMemo(
        () => ({
            '(max-width: 640px)': () => {
                setType('mobile');
            },
            '(min-width: 641px)': () => {
                setType('desktop');
            },
        }),
        []
    );
    useMediaQueries(queries);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const resetFilters = () => {
        dispatch({ type: 'RESET_STATE' });
    };

    return (
        <>
            <SiteHeader />

            <h2 className="bg-pale-blue text-center text-2xl md:text-4.5xl p-12 text-brand-dark md:mb-2">
                Top Online Deals &amp; Coupons
            </h2>

            {type === 'mobile' ? (
                <DealsFilterMobileSection
                    categories={categories}
                    state={state}
                    dispatch={dispatch}
                    count={deals.length}
                />
            ) : (
                <DealsFilterSection
                    categories={categories}
                    state={state}
                    dispatch={dispatch}
                    count={deals.length}
                />
            )}

            <div className="lg:w-[881px] md:mx-auto w-full pb-8 px-2">
                {loading ? (
                    <>
                        <div className="w-full my-6">
                            <Skeleton className="w-full my-6" height={300} />
                        </div>
                    </>
                ) : deals && deals.length > 0 ? (
                    <DealsSection
                        deals={deals}
                        hideTitle
                        hideMoreLink
                        location={'homepage_category_top_deals'}
                    />
                ) : (
                    <div className="flex">
                        <div className="h-full max-w-full mx-auto px-0 sm:px-4">
                            <div className="px-6">
                                <div className="flex mb-4 sm:mb-8">
                                    <div className="mx-auto mt-2">
                                        <CartWithCards />
                                    </div>
                                </div>
                                <p className="text-center text-dark-blue font-light text-[28px] leading[42px]">
                                    Sorry, we couldn’t find any deals that match these filters.
                                </p>
                                <p className="mb-9 text-center text-darkest mt-1 font-light text-[20px] leading-[30px]">
                                    Try adjusting your filters or searching for something else.
                                </p>
                                <div className="flex flex-col justify-center items-center mb-11 sm:mb-20">
                                    {' '}
                                    <Btn onClick={resetFilters}>Reset Filters</Btn>{' '}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <SiteFooter />
        </>
    );
});

export default TopDealsScreen;
